import productionList from '../../../config/containers/ProductionLine/productionList';
/* Another way to get project name ( and not from global state) */
export default productionList.default;
